/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import styled from 'styled-components';

import Fade from 'react-reveal/Fade';
import Flip from 'react-reveal/Flip';
import PText from '../components/PText';
import AboutImg from '../assets/images/about-page-img.png';
import AboutInfoItem from '../components/AboutInfoItem';
import ContactBanner from '../components/ContactBanner';
import pdf from '../assets/pdf/H_D_D_H_Vihan.pdf';

const AboutPageStyles = styled.div`
  padding: 20rem 0 10rem 0;
  .top-section {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2rem;
  }
  .left {
    flex: 3;
  }
  .right {
    flex: 2;
  }
  .about__subheading {
    font-size: 2.2rem;
    margin-bottom: 2rem;
    span {
      background-color: var(--deep-dark);
      padding: 0%.5rem;
      border: 8px;
    }
  }
  .about__heading {
    font-size: 3.6rem;
    margin-bottom: 3rem;
  }

  .about__info {
    margin-bottom: 4rem;
    .para {
      max-width: 100%;
    }
  }
  .button {
    font-size: 2.2rem;
    background-color: ${(props) =>
      props.outline ? 'transparent' : 'var(--gray-1)'};
    padding: 0.3em 1em;
    border-radius: 8px;
    display: inline-block;
    border: 2px solid var(--gray-1);
    color: ${(props) => (props.outline ? 'var(--gray-1)' : 'black ')};
  }

  .right {
    img {
      border: 1px solid var(--gray-1);
      border-radius: 10px;
    }
  }
  .about__info__items {
    margin-top: 15rem;
  }

  .about__info__item {
    margin-bottom: 10rem;
  }
  .about__info__heading {
    font-size: 3.6rem;
    text-transform: uppercase;
  }

  @media only screen and (max-width: 768px) {
    padding: 10rem 0;
    .top-section {
      flex-direction: column;
      gap: 5rem;
    }
    .about__subheading {
      font-size: 1.8rem;
    }

    .about__heading {
      font-size: 2.8rem;
    }
    .about__info__heading {
      font-size: 3rem;
    }
    .button {
      font-size: 1.8rem;
    }
  }
`;

export default function About() {
  return (
    <AboutPageStyles>
      <div className="container">
        <div className="top-section">
          <Fade left>
            <div className="left">
              <p className="about__subheading">
                Hi, I am <span>Danul Hivi Vihan</span>
              </p>
              <h2 className="about__heading">A Software Engineer </h2>
              <div className="about__info">
                <PText>
                  I am a software engineer with 3+ years of experience in the
                  industry. I am currently working at IFS R&D International Pvt
                  Ltd, where I am responsible for developing and maintaining
                  software applications. I have a strong background in software
                  development, with expertise in a variety of programming
                  languages and technologies. I am also proficient in software
                  testing and quality assurance.
                  <br />
                  <br /> Also, highly motivated and results-oriented individual
                  with a passion for software development. I am also a team
                  player and have a proven ability to work effectively in a
                  collaborative environment.
                  <br />
                  <br /> I am also eager to learn more about the IT related
                  anything and gain a vast amount of knowledge in this field. I
                  believe that my skills and experience, combined with my
                  passion for learning, would make me a valuable asset to any
                  company.
                </PText>
              </div>
              {/* <Button btnLink="#" btnText="Download CV" /> */}
              <button className="button">
                <a href={pdf} target="_blank" className="button">
                  Download CV
                </a>
              </button>{' '}
              {/* Changed the button */}
            </div>
          </Fade>
          <Fade right>
            <div className="right">
              <img src={AboutImg} alt="Hivi" />
            </div>
          </Fade>
        </div>
        <div className="about__info__items">
          <Fade bottom>
            <div className="about__info__item">
              <h1 className="about__info__heading">Experiences</h1>
              <AboutInfoItem
                title="2023 May - Present"
                items={['Software Engineer at IFS R&D International (Pvt) Ltd']}
              />
              <AboutInfoItem
                title="2022 Nov - 2023 Apr"
                items={['Trainee Software Engineer at BL360 (Pvt) Ltd']}
              />
              <AboutInfoItem
                title="2017 Sep - 2018 Sep"
                items={['Finance Internship at MAS Holdings']}
              />
            </div>
          </Fade>
          <Fade bottom>
            <div className="about__info__item">
              <h1 className="about__info__heading">Education</h1>
              <AboutInfoItem
                title="School"
                items={['Royal College, Colombo 07']}
              />
              <AboutInfoItem
                title="Degree"
                items={['Bachelor of Computer Science']}
              />
              <AboutInfoItem
                title="University"
                items={['University of Ruhuna, Sri Lanka']}
              />
            </div>
          </Fade>
          <Fade bottom>
            <div className="about__info__item">
              <h1 className="about__info__heading">My Skills</h1>
              <AboutInfoItem
                title="FrontEnd"
                items={[
                  'HTML',
                  'CSS',
                  'JavaScript',
                  'C#',
                  'ReactJS',
                  'Blazor',
                  'MAUI',
                  'XAML',
                ]}
              />
              <AboutInfoItem
                title="BackEnd"
                items={['NodeJS', 'PHP', 'FireBase', 'MySQL', '.Net', 'MSSQL']}
              />
              <AboutInfoItem
                title="Programming"
                items={['C', 'Java', 'Python', 'C#']}
              />
              <AboutInfoItem
                title="Design"
                items={[
                  'PhotoShop',
                  'Figma',
                  'AfterEffects',
                  'PremierePro',
                  'XD',
                  'Illustrator',
                  'Blender',
                ]}
              />
              <AboutInfoItem
                title="Mobile Dev"
                items={['Flutter', 'Android', 'MAUI', 'XAML', 'C#', 'Dart']}
              />
              <AboutInfoItem
                title="Softwares"
                items={[
                  'VSCode',
                  'Visual Studio',
                  'Android Studio',
                  'MS Office',
                ]}
              />
            </div>
          </Fade>
        </div>
      </div>
      <Flip top>
        <ContactBanner />
      </Flip>
    </AboutPageStyles>
  );
}
